import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { EntityType } from "@mapmycustomers/shared";

import { setEntityTypesWithExternalPreview } from "@app/store/entityView/actions";

import useSceneLastViewMode from "../../util/hook/useSceneLastViewMode";

import ForecastPage from "./component/ForecastPage";
import KanbanPage from "./component/KanbanPage";
import DealListPage from "./component/ListPage";
import DealRecordPage from "./DealRecordPage";
import ViewMode from "./enum/ViewMode";
import FilePage from "./FilePage";

interface Props {
  setEntityTypesWithExternalPreview: typeof setEntityTypesWithExternalPreview;
}

const DealPage: React.FC<Props> = ({ setEntityTypesWithExternalPreview }) => {
  const { path } = useRouteMatch();
  const lastViewMode = useSceneLastViewMode(path, ViewMode, ViewMode.KANBAN);

  useEffect(() => {
    setEntityTypesWithExternalPreview([EntityType.DEAL]);
    return () => {
      setEntityTypesWithExternalPreview([]);
    };
  }, [setEntityTypesWithExternalPreview]);

  return (
    <Switch>
      <Route path={`${path}/:did/files/:fileId`} component={FilePage} />
      <Route>
        <Switch>
          <Route path={`${path}/${ViewMode.LIST}`} component={DealListPage} />
          <Route path={`${path}/${ViewMode.KANBAN}`} component={KanbanPage} />
          <Route path={`${path}/${ViewMode.FORECAST}`} component={ForecastPage} />
          <Route exact path={path}>
            <Redirect to={`${path}/${lastViewMode}`} />
          </Route>
        </Switch>
        <Route
          path={`${path}/:viewMode(${Object.values(ViewMode).join("|")})/:did?`}
          component={DealRecordPage}
        />
      </Route>
    </Switch>
  );
};

const mapDispatchToProps = {
  setEntityTypesWithExternalPreview,
};

export default connect(null, mapDispatchToProps)(DealPage);
